import * as opacity_fe from './frontend/opacity-picker-fe.js';
import * as testimonials_fe from './frontend/testimonials-fe.js';
import * as scroll from './frontend/scroll.js';
import { doOnloadQuery } from './frontend/query.js';
import * as utility from './frontend/utility.js';
import * as infomap from './frontend/infomap.js';

window.addEventListener('DOMContentLoaded', (event) => {

    let processlist = document.querySelectorAll('[data-process]');
    //do our process list - switch is fastest
    processlist.forEach((item) => {
        let process = item.getAttribute('data-process');
        switch (process){
            case "doProgressiveHeader" :
                doProgressiveHeader(item);
                break;

            // case "atScroll" :
            //     console.log("atScroll found");
            //     let options = {};
            //     let hasoptions = false;
            //     if( item.hasAttribute('data-callback')){
            //         hasoptions = true;
            //         options.cb = function(el){ scroll[item.dataset.callback](el) }
            //     }
            //     if( item.hasAttribute('data-scroll-offset')) {
            //         hasoptions = true;
            //         options.rootMargin = item.dataset.scrollOffset;
            //         console.log(options);
            //     }
            //     if( hasoptions ){
            //         scroll.addObserver(item, options)
            //     } else {
            //         scroll.addObserver(item);
            //     }
            //     break;

            case "doOnloadQuery" :
                doOnloadQuery(item)
                break;
            case "doHeightMatch":
                utility.doHeightMatch(item);
                break;
            case "addMapClick":
                utility.addMapClick(item);
                break;
            case "setInitialState":
                infomap.setInitialState(item);
                break;
            default:
                //she doesn't even go here
                break;
        }
    });
    window.doAccordionClicks();
    infomap.doInfoMapClicks();
    window.onload_data_fetch();
    window.doMobileMenuClick();
    window.setupModals();
    opacity_fe.doOpacityClicks();
    testimonials_fe.doTestimonialClicks();
});
// window.addEventListener('scroll', (event)=>{ console.log(window.scrollY)});
window.addEventListener('resize', (event) =>{
    let processlist = document.querySelectorAll('[data-process]');
    //do our process list - switch is fastest
    console.log("resized");
    processlist.forEach((item) => {
        let process = item.getAttribute('data-process');
        switch (process){
            case "doProgressiveHeader" :
                console.log("Doing Progressive Header");
                window.doProgressiveHeader(item);
                break;
            default:
                //she doesn't even go here
                break;
        }
    });
});
